import Container from "react-bootstrap/esm/Container";
import { ProjectTable } from "./ProjectTable";

export default function Home(props) {
  return (
    <Container className="mt-3">
      <ProjectTable user={props.user} />
    </Container>
  );
}
